// React
import React, { useMemo, useRef } from "react";

// MUI
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Apartment } from "@mui/icons-material";

// Libraries
import { useTranslation } from "react-i18next";
import { styles } from "../AppointmentFilters/styles";

const ClinicFilter = (props) => {
  const { options, selectedClinics, setSelectedClinics, open, setOpenPicker } =
    props;
  const { t } = useTranslation();
  const ref = useRef(null);

  const sortedClinics = useMemo(() => {
    return [...options].sort((a, b) => {
      const nameA = t("clinic.name", { clinic: a.Clinic }).toLowerCase();
      const nameB = t("clinic.name", { clinic: b.Clinic }).toLowerCase();
      return nameA.localeCompare(nameB, "fr", { sensitivity: "base" });
    });
  }, [options, t]);

  return (
    <Autocomplete
      id="clinic-filter"
      multiple
      limitTags={1}
      noOptionsText={t("availableAppointments.noOptions")}
      open={open}
      onOpen={() => setOpenPicker(true)}
      onClose={(e, reason) => {
        if (reason === "toggleInput" && e.type === "click") {
          return;
        }
        setOpenPicker(false);
      }}
      disablePortal
      value={selectedClinics}
      onChange={(_, value) => {
        setSelectedClinics(value);
        if (ref?.current) {
          ref.current.blur();
        }
      }}
      options={sortedClinics}
      getOptionLabel={(option) => t("clinic.name", { clinic: option.Clinic })}
      sx={{
        ...styles.gridItem,
        ...styles.autocomplete,
      }}
      popupIcon={null}
      renderInput={(params) => (
        <TextField
          {...params}
          color="secondary"
          inputRef={ref}
          label={
            open || selectedClinics.length
              ? t("availableAppointments.clinic")
              : ""
          }
          placeholder={
            open || selectedClinics.length
              ? ""
              : t("availableAppointments.clinic")
          }
          slotProps={{
            listbox: { sx: styles.autoCompleteList },
            input: {
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <IconButton
                      sx={styles.icon}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenPicker(!open);
                      }}
                    >
                      <Apartment />
                    </IconButton>
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
            },
          }}
        />
      )}
      slotProps={{
        chip: { size: "small" },
        listbox: { sx: styles.autoCompleteList },
        clearIndicator: {
          sx: { visibility: "visible" },
          onClick: (e) => {
            e.stopPropagation();
            setSelectedClinics([]);
            if (ref?.current) {
              ref.current.blur();
            }
          },
        },
      }}
    />
  );
};

export default ClinicFilter;
